import creditCardType, { types as CardType } from 'credit-card-type';

export const SupportedCardTypes = [CardType.VISA, CardType.MASTERCARD, CardType.DISCOVER, CardType.AMERICAN_EXPRESS];

interface CreditCardType {
	type: string;
	niceType: string;
}

export interface CreditCardInfo {
	cardNumber: string;
	expMonth: string;
	expYear: string;
	cvv: string;
	creditCardType: string;
}

export function getCreditCardType(cardNumber: string): CreditCardType | null {
	if (!cardNumber) {
		return null;
	}

	const ccType = creditCardType(cardNumber);

	if (ccType.length === 0) {
		return null;
	}

	return ccType[0];
}

export function getCreditCardTypeForServer(cardNumber: string) {
	if (!cardNumber) {
		console.warn(`No card number provided, returning 'Other'.`);
		return 'OTHER';
	}

	const ccType = getCreditCardType(cardNumber);

	if (ccType === null) {
		console.warn(`Unable to determine card type. Returning 'Other'`);
		return 'OTHER';
	}

	const reversedTypes = {};

	Object.keys(CardType).forEach((key) => {
		reversedTypes[CardType[key]] = key;
	});

	const mapped = reversedTypes[ccType.type];

	if (mapped) {
		return mapped;
	}

	return 'OTHER';
}
